import React from "react";
import EventName from "../../EventName";
import CustomAlert from "../../CustomAlert"; 

const OrganizerData = () => {
  console.log("OrganizerData component loaded"); // Debugging line

  // Inline styles to match sidebar
  const containerStyle = {
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '5px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    maxWidth: '800px',
    margin: 'auto',
  };

  const headerStyle = {
    fontSize: '24px',
    marginBottom: '20px',
    color: '#007272',
  };

  const formGroupStyle = {
    marginBottom: '15px',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '5px',
    fontWeight: '600',
    color: '#333333',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ced4da',
    fontSize: '14px',
  };

  const selectStyle = {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ced4da',
    fontSize: '14px',
  };

  const buttonStyle = {
    padding: '10px 20px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#007272',
    color: '#ffffff',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '600',
  };

  return (
    <div style={containerStyle}>
      <h3 style={headerStyle}>Organizer Information</h3>
      <form action="/submit" method="POST">
        <div style={formGroupStyle}>
          <label htmlFor="travel" style={labelStyle}>
            How will you travel to the Event?
          </label>
          <select id="travel" name="travel" style={selectStyle} required>
            <option value=""></option>
            <option value="Car">Car</option>
            <option value="Train">Train</option>
            <option value="Flight">Flight</option>
          </select>
        </div>

        <div style={formGroupStyle}>
          <label htmlFor="transportation" style={labelStyle}>
            Type of Transportation
          </label>
          <select id="transportation" name="transportation" style={selectStyle} required>
            <option value=""></option>
            <option value="Economy">Economy</option>
            <option value="Business">Business</option>
            <option value="FirstClass">First Class</option>
          </select>
        </div>

        <div style={formGroupStyle}>
          <label htmlFor="location" style={labelStyle}>
            Starting Location of your journey
          </label>
          <input type="text" id="location" name="location" style={inputStyle} placeholder="Enter location" required />
        </div>

        <div style={formGroupStyle}>
          <label htmlFor="time" style={labelStyle}>
            How long will you attend the event?
          </label>
          <select id="time" name="time" style={selectStyle} required>
            <option value=""></option>
            <option value="1">1 Day</option>
            <option value="2">2 Days</option>
            <option value="3">3 Days</option>
          </select>
        </div>

        <div style={formGroupStyle}>
          <label htmlFor="accommodation" style={labelStyle}>
            Which type of hotel will you stay in?
          </label>
          <select id="accommodation" name="accommodation" style={selectStyle} required>
            <option value="4">NA</option>
            <option value="1">3 Star</option>
            <option value="2">4 Star</option>
            <option value="3">5 Star</option>
          </select>
        </div>

        <div style={formGroupStyle}>
          <label htmlFor="meal" style={labelStyle}>
            Meal Preference
          </label>
          <select id="meal" name="meal" style={selectStyle} required>
            <option value="6">Veg</option>
            <option value="7">Non-Veg</option>
            <option value="8">Vegan</option>
          </select>
        </div>

        <div style={formGroupStyle}>
          <button type="submit" style={buttonStyle}>Save</button>
        </div>
      </form>
    </div>
  );
};

export default OrganizerData;
